import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ContactList from "./ContactList";
import type ContactListsContact from "./ContactListsContact";
import type Outlet from "./Outlet";
import type { Email, Phone } from "./types";

@Model()
class OutletDesk extends ApplicationRecord {
  static jsonapiType = "outlet_desks";

  @HasMany() contactLists: ContactList[];

  @HasMany() contactListsContacts: ContactListsContact[];

  @Attr({ persist: false }) documentId: string;

  @Attr() email: string;

  @Attr({ persist: false }) emails: Email[];

  @Attr({ persist: false }) invalidEmail: boolean;

  @Attr() name: string;

  @BelongsTo() outlet: Outlet;

  @Attr() outletId: number;

  @Attr() phone: string;

  @Attr({ persist: false }) phones: Phone[];
}

export default OutletDesk;
